module.exports = __webpack_public_path__ + "img/eye-o.a013984a.svg";